import React from 'react'
import { Button, Modal, ModalBody } from 'reactstrap';
import { CgClose } from 'react-icons/cg';
import { BsQuestionSquare } from 'react-icons/bs';
import "./ModalFormularioProducto.css";
import { estiloColorError, estiloComboBox, estilosModal } from '../../../Services/PaletaDeColores';
import { validarRegistroCOFEPRIS, validarLetrasNumerosEspaciosGuionesProductoPuntoComa } from '../../../Services/Validaciones';
import ReactTooltip from "react-tooltip";
import { getListaPlagasControlarUpdate } from '../../../Services/Api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const todaslasopcionesdisponibles = -1

export default class ModalFormularioPlagasControlar extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            show: props.show,
            confirmarenvio: false,
            accion: props.accion, // 1 Nuevo, 2 editar
            titulo: props.titulomodal,
            listatipoplagas: props.listatipoplagas,
            listaplagas: props.listaplagas,

            idtipoplaga: (props.accion == 2) ? (props.item.idtipo_plaga) : todaslasopcionesdisponibles,
            vermsgerrorcampoidtipoplaga: false,
            msgerrorcampoidtipoplaga: "",

            idplaga: (props.accion == 2) ? (props.item.idcatalogo_plaga) : todaslasopcionesdisponibles,
            vermsgerrorcampoidplaga: false,
            msgerrorcampoidplaga: "",

            txtcomentario: (props.accion == 2) ? (props.item.descripcion) : '',
            vermsgerrorcampotxtcomentario: false,
            msgerrorcampotxtcomentario: "",

            colormsgerror: estiloColorError().msgerror,
            estilosmodal: estilosModal(),
            colortipolbl: estiloComboBox().colorcombolbl,
            colorcbxtipolbl: estiloComboBox().colorcbxlbl,
            colorbordertipo: estiloComboBox().colorbordercombo,
            colorfondotipo: estiloComboBox().colorfondocombo
        }

    }

    showModal = (accion) => {
        this.setState({ show: false });
        setTimeout(() => {
            this.props.cerrarModal(accion);
        }, 200);
    }

    setLoadingSpinner = (bandera) => {
        this.props.setloadingspinner(bandera);
    }

    escribir = (prop) => (event) => {
        this.setState({ [prop]: event.target.value });
    }

    cambiarTipo = (campo, id) => {
        if (campo == "idtipoplaga") {
            this.setState({ idtipoplaga: id, idplaga: todaslasopcionesdisponibles })
        } else {
            this.setState({ [campo]: id })
        }
    }

    guardarCambios = async () => {
        this.setState({ vermsgerrorcampoidtipoplaga: false })
        this.setState({ vermsgerrorcampoidplaga: false })
        this.setState({ vermsgerrorcampotxtcomentario: false })
        let validacionescorrectas = true

        if (this.state.idtipoplaga == todaslasopcionesdisponibles) {
            validacionescorrectas = false;
            this.setState({ msgerrorcampoidtipoplaga: "Seleccione un tipo de plaga" })
            this.setState({ vermsgerrorcampoidtipoplaga: true })
        }

        if (this.state.idplaga == todaslasopcionesdisponibles) {
            validacionescorrectas = false;
            this.setState({ msgerrorcampoidplaga: "Seleccione una plaga" })
            this.setState({ vermsgerrorcampoidplaga: true })
        }

        if (this.state.txtcomentario.trim().length > 0) {
            let longitudvalidacomentario = { longitudminima: 1, longitudmaxima: 100 };
            let campocomentario = validarLetrasNumerosEspaciosGuionesProductoPuntoComa(this.state.txtcomentario.trim(), longitudvalidacomentario);
            if (campocomentario.codigo == "invalid") {
                this.setState({ msgerrorcampotxtcomentario: campocomentario.mensaje })
                this.setState({ vermsgerrorcampotxtcomentario: true })
                validacionescorrectas = false;
            }
        }


        if (validacionescorrectas) {
            this.setLoadingSpinner(true)
            let json = {
                "idcatalogoproducto_plaga": this.state.accion == 1 ? ("0") : (this.props.item.idcatalogoproducto_plaga),
                "idcatalogoproducto": this.props.item.idcatalogoproducto,
                "idcatalogo_plaga": this.state.idplaga,
                "descripcion": this.state.txtcomentario
            }
            var resp = await getListaPlagasControlarUpdate(json);

            if(resp.code == 0){
                if (this.state.accion == 1) {
                    this.showModal('1')
                }
                else if (this.state.accion == 2) {
                    this.showModal('2')
                }
            }
            else if(resp.code == 200){
                this.setLoadingSpinner(false);
                this.setState({ confirmarenvio: !this.state.confirmarenvio })
                toast.error(resp.message, { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
                return;
            }
            else if(resp.code == 300){
                this.setLoadingSpinner(false);
                this.setState({ confirmarenvio: !this.state.confirmarenvio })
                toast.error(resp.message, { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
                return;
            }
            else if(resp.code == 400){
                this.setLoadingSpinner(false);
                this.setState({ confirmarenvio: !this.state.confirmarenvio })
                toast.error("Operación rechazada, vuelve a intentar", { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
                return;
            }
            else if (resp.code == 1000) {
                this.setLoadingSpinner(false);
                toast.error(resp.message, { autoClose: 1000, position: toast.POSITION.TOP_LEFT });
                return;
            }else{
                this.setLoadingSpinner(false);
                this.setState({ confirmarenvio: !this.state.confirmarenvio })
                toast.error("Error de conexión", { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
            }
        }

    }

    render() {
        return (

            <>
                <ToastContainer />
                <Modal isOpen={this.state.show}
                    size="md"
                    aria-labelledby=""
                    centered>
                    <ModalBody>

                        <CgClose className='icoCloseModal' onClick={() => this.showModal('0')} />
                        <label className="modalLblTitulo letraTitulos" style={{ Color: this.state.estilosmodal.colorlbltextomodal }} >{this.state.titulo}</label>

                        <br />
                        <br />
                        <div className="divCuerpoModal">

                            <div className="divContenedorModal" style={{ backgroundColor: this.state.estilosmodal.fondocontenedormodal }}>

                                <p className='lblSubTitulosModal letraTitulos' style={{ color: this.state.estilosmodal.colorlblsubtitulosmodal }}>Tipo plaga</p>
                                {this.state.accion == 2 || this.state.accion == 1 ? (
                                    <div className='col lblSubTitulosModal '>
                                        <div className='comboModal lblTextoModal' style={{ borderBottom: this.state.colorbordertipo }}>

                                            <div className="selectBox ">
                                                <select className="cbxTexto letraNormal"
                                                    onChange={(event) => this.cambiarTipo("idtipoplaga", event.target.value)}>
                                                    {<option value={todaslasopcionesdisponibles} key={"tipo_x"} selected={todaslasopcionesdisponibles == this.state.idtipoplaga}>Seleccionar</option>}
                                                    {this.state.listatipoplagas.map((i, index) => (
                                                        <option value={i.idtipo_plaga} key={"tipo_" + index} selected={i.idtipo_plaga == this.state.idtipoplaga} >{i.tipo} </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                ) :
                                    null
                                }
                                {this.state.vermsgerrorcampoidtipoplaga ? <p className="msgError letraNormal"
                                    style={{ color: this.state.colormsgerror }}>{this.state.msgerrorcampoidtipoplaga}</p> : null}


                                <p className='lblSubTitulosModal letraTitulos' style={{ color: this.state.estilosmodal.colorlblsubtitulosmodal }}>Plaga</p>
                                {this.state.accion == 2 || this.state.accion == 1 ? (
                                    <div className='col lblSubTitulosModal '>
                                        <div className='comboModal lblTextoModal' style={{ borderBottom: this.state.colorbordertipo }}>

                                            <div className="selectBox ">
                                                <select className="cbxTexto letraNormal"
                                                    onChange={(event) => this.cambiarTipo("idplaga", event.target.value)}>
                                                    {<option value={todaslasopcionesdisponibles} key={"tipo_x"} selected={this.state.idplaga == todaslasopcionesdisponibles} >
                                                        {this.state.idtipoplaga == todaslasopcionesdisponibles ? "Seleccione primero un tipo" : "Seleccionar"}
                                                    </option>}
                                                    {this.state.idtipoplaga != todaslasopcionesdisponibles && this.state.listaplagas
                                                        .filter((e) => e.idtipo_plaga == this.state.idtipoplaga)
                                                        .map((i, index) => (
                                                            <option value={i.idcatalogo_plaga} key={"tipo_" + index} selected={i.idcatalogo_plaga == this.state.idplaga} >{i.plaga} </option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                ) :
                                    null
                                }
                                {this.state.vermsgerrorcampoidplaga ? <p className="msgError letraNormal"
                                    style={{ color: this.state.colormsgerror }}>{this.state.msgerrorcampoidplaga}</p> : null}


                                <p className='lblSubTitulosModal letraTitulos' style={{ color: this.state.estilosmodal.colorlblsubtitulosmodal }}>Descripción</p>
                                {this.state.accion == 2 || this.state.accion == 1 ? (
                                    <input className='lblTextoModal letraNormal' style={{ color: this.state.estilosmodal.colorlbltextomodal, backgroundColor: this.state.estilosmodal.fondocontenedormodal, border: 'none', borderBottom: this.state.estilosmodal.colorborderbottom }}
                                        type={'text'} value={this.state.txtcomentario} onChange={this.escribir("txtcomentario")}></input>
                                ) : <label className='lblTextoModal letraNormal' style={{ color: this.state.estilosmodal.colorlbltextomodal, borderBottom: this.state.estilosmodal.colorborderbottom }}>{this.state.txtcomentario}</label>}

                                {this.state.vermsgerrorcampotxtcomentario ? <p className="msgError letraNormal"
                                    style={{ color: this.state.colormsgerror }}>{this.state.msgerrorcampotxtcomentario}</p> : null}

                            </div>
                            {/*this.state.accion == 2 ? (
                                <>
                                    <BsQuestionSquare className='icoQuestionModal' data-tip data-for="registerTip" />
                                    <ReactTooltip id="registerTip" place="top" effect="solid" className='tolTipFormat'>
                                        Creado: {this.props.item.fechacreacion}
                                        <br />
                                        Actualizado: {this.props.item.fechaactualizacion}
                                    </ReactTooltip>
                                </>
                            ) : null*/}
                        </div>

                        {this.state.accion == 2 || this.state.accion == 1 ? (
                            <>
                                <br />
                                <div className="modalDetallesCheck" onClick={() => this.setState({ confirmarenvio: !this.state.confirmarenvio })}>
                                    <input type="checkbox" checked={this.state.confirmarenvio} /> Confirmar información
                                </div>
                                <br />
                                <div className="divBtnContenedorModal" >
                                    <Button className="btnCancelModal" onClick={() => this.showModal('0')}>Cancelar</Button>
                                    <Button className="btnAceptarModal" onClick={() => this.guardarCambios()} disabled={!this.state.confirmarenvio} >Guardar</Button>
                                </div>
                            </>
                        ) : null}

                    </ModalBody>

                </Modal>
            </>
        )
    }

}

